import React from 'react';

import { RecommendationsNewProvider } from 'recommendationsNew/contexts/recommendationsNewContext';
import CloudWasteChart from 'recommendationsNew/components/heatMap/cloudWaste/cloudWasteChart';
import { TableHeaderProvider } from 'shared/components/tableHeader/TableHeaderContext';
import { HeatMapProvider } from 'recommendationsNew/components/heatMap/contexts/heatMapContext';
import { PANEL_COMPONENT_TYPES } from 'usage/containers/CustomDashboard/constants/customDashboardConstants.js';
import WasteTrackerChart from 'recommendationsNew/components/heatMap/cloudWaste/wasteTrackerChart.js';
import { NewRecommendationDashboardContext } from '../NewRecommendationDashboardContext';

const RecommendationCloudWasteChart = (props) => {
  const { state, data, type } = props;
  return (
    <RecommendationsNewProvider>
      <TableHeaderProvider>
        <HeatMapProvider>
          <NewRecommendationDashboardContext filterState={state} />
          {type === PANEL_COMPONENT_TYPES.CLOUD_WASTE ? (
            <CloudWasteChart externalData={data} />
          ) : (
            <WasteTrackerChart externalData={data} externalDateGranularity={state?.dateGranularity} />
          )}
        </HeatMapProvider>
      </TableHeaderProvider>
    </RecommendationsNewProvider>
  );
};

export default RecommendationCloudWasteChart;
